<template>
	<div>
		<el-card shadow="never">
			<el-form ref="form" :model="formData" :rules="rules" label-width="100px" size="small">
				<el-form-item label="新单价" prop="price">
					<el-input size="small" v-model="formData.price" placeholder="请输入新单价">
						<template slot="append">元/度或吨</template>
					</el-input>
				</el-form-item>
				<el-form-item label="新电损">
					<el-input size="small" v-model="formData.loss" placeholder="请输入新电损"></el-input>
				</el-form-item>
			</el-form>

			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSaveChangePrice">确 定</el-button>
				<el-button size="small" @click="doClose">取 消</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import dlgForm from "@/mixin/dlgForm";
export default {
	name: "ChangePriceForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				price: [
					{ required: true, message: "请输入新单价", trigger: "blur" },
					{ min: 1, message: "必须是正数", trigger: "blur" },
				],
			},
		};
	},
	methods: {
		doSaveChangePrice() {
            const url = "/meter/web/basic/modifyPriceBatch";
            this._doSaveForm(this.$refs.form, url, 'PUT');
		},
	}
};
</script>
